<template>
	<div>
		<no-data v-if="!missionsList.length && dataLoadState"></no-data>
		<!-- <div class="notification-header shadow-bottom " v-if="missionNotice">
			<div class="container container--narrow pdt-16 pdb-16">
				<div class="d-flex align-items-center pdb-4">
					<span class="notification-icon min-w-36 min-h-36">
						<i	class="material-icons t-color-secondaryBtnText">notifications</i>
					</span>
					<div class="t-body2 font-m l-spacing42 pdl-16">
						{{$t('199')}}
					</div>
				</div>
			</div>
		</div> -->
		<div v-if="missionsList.length" class="container container--narrow pdt-30">
			<div class="mdc-card  mgb-50 pdb-8">
				<div class="t-headline7 font-m  mgb-16 mgr-12 pdt-24 pdl-24"> {{$t('200')}} </div>

				<div v-for="(mission, index) in missionsList" :key="index" >
					<div :class="[statusTab === 'WAITING'?'':'cursor-pointer', terminatedMission(mission.status) ? 'mdc-chip--disabled' : '']"
               class="d-flex pdt-16 mgl-24 my-course-list position-relative min-h-auto learn-missionCard" tabindex="0" @click="moveMission(mission)" @keypress="moveMission(mission)">
					<div class="list-image-small40">
						<img alt="" class="w-40 h-40 pdt-4" src="../../../images/misson.svg">
					</div>
					<div class="flex-grow-1 pdl-20">
						<div class="mgb-15">
							<div class="d-flex justify-content-between align-items-center pdr-24">
								<div class="t-body1  font-r pdr-24 l-spacing48 pdb-4">
									{{ mission.name }}
								</div>
									<div v-if="mission.feedbackCount" class="d-flex align-items-top">
										<span v-if="mission.feedbackUnread"  class="position-relative new-chat-notice">
											<i	class="material-icons t-color-bodyBlueGray">chat_bubble_outline</i>
										</span>
											<span v-else class="position-relative">
										<i	class="material-icons t-color-bodyBlueGray">chat_bubble_outline</i>
											</span>
										<span class="pdl-5 t-color-bodyBlueGray font-r t-body3 l-spacing42">{{ mission.feedbackCount }}</span>
								</div>
							</div>

							<div class="d-flex justify-content-between align-items-center pdr-24">
									<div :class="statusAddClass(mission.status)" class="d-flex justify-content-between">
										<i v-if="isMaterialIcon(mission.status)" class="material-icons icon15 pdr-4">
											<img v-show="mission.status === 'UNDER_EVALUATION'" alt="" src="@/images/mission/process-done.svg" />
												{{ statusMaterialIcon(mission.status) }}
										</i>
											<div class="t-body2 font-r t-line-h-22 l-spacing42 mgr-8 " v-html="statusTranslate(mission.status)"></div>
										<div v-if="mission.status === 'RESUBMIT'" class="lerner-list-status-tag t-helper font-r t-line-18 pdt-2 pdb-2 pdr-8 pdl-8 t-color-whiteHigh bg-iconInactive  t-nowrap mgb-4">{{$t('teacher.10121')}}</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div v-if="missionsList.length > index+1"  class=""></div>
				</div>
			</div>
		</div>
	</div>
</template>



<script>
/**
 * 나의 학습 상세 미션정보
 *
 * @author minkyoung.park@emcast.com
 * @author
 * @since 2019.07
 */

// Components/Mixin/Extend/API 선언
import microLearnApi from '@/api/microLearnApi.js'
import NoData from '../../common/NoDataMissionLesson.vue'
import {MDCRipple} from '@material/ripple'
import { log } from 'util'

const Status = {
  WAITING: {
	materialText: "",
    translateKey: "198", // 과제 시작일 전
    scoreClass: "t-color-bodyGrayA"
  },
  SUBMISSIBLE: {
	materialText: "",
    translateKey: "208", // 제출하기
    scoreClass: "t-color-bodyBlueGray"
  },
  SUBMITTED: {
	materialText: "",
    translateKey: "201", // 제출완료
    scoreClass: "t-color-bodyBlueGray"
  },
  UNDER_EVALUATION: {
	materialText: "",
    translateKey: "3484", // 평가 중
    scoreClass: "t-color-lectureAqua"
  },
  EVALUATED: {
	materialText: "done",
    translateKey: "206", // 평가 완료
    scoreClass: "t-color-contentBlue"
  },
  EVALUATION_TERMINATION: {
	materialText: "",
    translateKey: "207", // 과제 종료
    scoreClass: "t-color-bodyGrayA"
  },
  SUBMISSION_TERMINATION: {
	materialText: "",
    translateKey: "205", // 제출 불가
    scoreClass: "t-color-bodyGrayA"
  },
  REJECT: {
    materialText: "warning",
    translateKey: "204", // 반려
    scoreClass: "t-color-lectureRed"
  },
}

export default {
	components: {
		'no-data': NoData
	},
	props: ['basicData'],
	watch: {
    $route(to) {
			if(to) {
				this.fetchData();
			}
    }
	},
	data() {
		return {
			missionsData: null,
			missionsList: [],
			dataLoadState: false,
			missionNotice: false,
			statusTab: null
		}
	},
	mounted() {
		this.statusTab = this.$route.query.status;
		this.fetchData();
	},

	updated() {
		const ripples = [].map.call(document.querySelectorAll('.ripple-item'), function(el) {
			let ripple = new MDCRipple.attachTo(el)
			return ripple;
		})

	},


	methods: {

		// 미션정보 API 호출 및 데이터 설정
		fetchData() {
			let params = this.setParams();

			this.$showLoading(this.$refs.missionList)
      microLearnApi.learnViewMission(params).then((response) => {
				this.missionsList = response.data.data

				this.$hideLoading()
				this.dataLoadState = true

				if(this.missionsList.length > 0) {
          microLearnApi.learnViewMissionNotice(params).then((response) => {
						this.missionNotice = response.data.data
					}).catch((err) => {
						console.log('__err__', err);
					})
				}

				let submissibleList = _.filter(this.missionsList, function(o) { return o.status === 'SUBMITTED' || o.status === 'SUBMISSIBLE' });

				if (submissibleList) {
					let missionId = _.head(submissibleList).id;
					this.setMissionId(missionId);
				}
			}).catch((err) => {

			});

		},

		// 파라미터 설정
		setParams() {
			const params = {
				learnId: this.$route.params.learnId
			}
			return params;
		},

		terminatedMission(status) {
			const endMission = ['SUBMISSION_TERMINATION', 'EVALUATION_TERMINATION'];
			return endMission.includes(status) || this.statusTab === 'WAITING';
		},

		submitMission(status) {
			const startMission = ['SUBMITTED', 'EVALUATED', 'REJECT', 'UNDER_EVALUATION'];
			return startMission.includes(status) || this.statusTab === 'WAITING';
		},

		isMaterialIcon(status) {
			const hasMaterialIcon = ['REJECT', 'EVALUATED', 'UNDER_EVALUATION'];
			return hasMaterialIcon.includes(status);
		},

		moveMission(mission) {

      const termMission = this.terminatedMission(mission.status);
      if(termMission) {
        return false;
      }
      localStorage.setItem("learnDetails", "backtoLearn");

			const subMission = this.submitMission(mission.status);
			if(subMission) {
				this.$router.push({
					name: 'MicroMissionViewSubmit',
					params: {
						assignmentId: mission.id
					},
				});
			} else {
				this.$router.push({
					name: 'MicroMission',
					params: {
						assignmentId: mission.id
					},
					query: this.$route.query
				});
			}
		},

		setMissionId(missionId) {
			this.$emit('setMissionId', missionId)
		},

		statusMaterialIcon(status) {
      return Status[status].materialText;
      },

    statusTranslate(status) {
			const learnStart = this.$moment(this.basicData.periodLearning.start).format('L');

			if (status === 'WAITING') {
				return this.$t('198', {str: learnStart});
			} else {
				return this.$t(Status[status].translateKey);
			}
    },

		statusAddClass(status) {
			return this.$t(Status[status].scoreClass);
		},

		// newFeedbackCommentClass(mission) {
    //   return mission.feedbackUnread ? 'misson-comment-notice' : '';
    // }
	}
}
</script>

<style scopped>

</style>
